export enum NotificationStateEnum {
  READ = "read",
  UNREAD = "unread",
}
